import { useQuery } from "@tanstack/react-query";
import { fetchUserFavorites } from "./api/products";

export const useGetUserFavorites = (token) => {
  return useQuery({
    queryKey: ["userFavorites"],
    queryFn: () => fetchUserFavorites(token),
  });
};
